const nonEmptyText = (value) => typeof value === 'string' && value.trim() ? value : '';

export const getLiveAgentName = (value, fallback = 'Live agent') => {
  const name = nonEmptyText(value?.agentname) || nonEmptyText(value?.agentName)
    || nonEmptyText(value?.label);
  return !name || ['user', 'system'].includes(name.toLowerCase()) ? fallback : name;
};

export const getLiveAgentMessage = (activity, fallbackName = 'Live agent') => {
  // if (activity?.from?.id === 'user' || activity?.from?.role === 'user') return null;
  console.log('activity.type:', activity.type);
  console.log('activity.name:', activity.name);
  if (activity?.type === 'event' && activity.name === 'agentmessages') {
    const value = activity.value;
    if (typeof value?.label === 'string' && value.label.toLowerCase() === 'user') return null;
    const text = nonEmptyText(value?.message);
    return text ? { text, agentName: getLiveAgentName(value, fallbackName) } : null;
  }

  if (activity?.type !== 'message') return null;
  const attachment = Array.isArray(activity.attachments)
    ? activity.attachments.find(item => item?.contentType === 'agentMessages')
    : null;
  if (attachment) {
    const text = nonEmptyText(attachment.content?.text);
    return text ? { text, agentName: getLiveAgentName(attachment.content, fallbackName) } : null;
  }

  if (activity.from?.role === 'agent' || activity.from?.id === 'incontact') {
    const text = nonEmptyText(activity.text);
    return text ? {
      text,
      agentName: getLiveAgentName({ agentName: activity.from?.name }, fallbackName),
    } : null;
  }
  return null;
};